import { mapErrorMessage } from 'Utils/mapErrorMessage';
import * as types from '../constants/onboarding';

const INITIAL_STATE = {
  success: false,
  error: null,
  data: null,
  orgSuccess: false,
  orgData: null,
  loading: false,
};

export default function onboardingReducer(state = INITIAL_STATE, action) {
  const newState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case types.API_CREATE_ORG:
      return {
        ...newState,
        success: false,
        error: null,
        loading: true,
      };
    case types.API_CREATE_ORG_SUCCESS:
      return {
        ...newState,
        orgSuccess: true,
        error: null,
        loading: false,
        orgData: action.response.data,
      };

    case types.API_CREATE_ORG_FAILED:
      return {
        ...newState,
        success: false,
        orgSuccess: false,
        loading: false,
        error: mapErrorMessage(action),
      };

    case types.RESET_ONBOARDING:
      return {
        success: false,
        error: null,
        data: null,
        orgSuccess: false,
        orgData: null,
        loading: false,
      };

    default:
      return newState;
  }
}
